export interface FinderOption<T = string> {
  /** 英文文案（默认展示） */
  label: string;
  /** 中文文案，用户语言为 zh_CN 时展示；缺省回退到 label */
  zh?: string;
  /** 请求参数，固定英文，不随语言变化 */
  value: T;
}

export const seniorities: FinderOption[] = [
  { label: "Owner / Founder", zh: "创始人", value: "Owner / Founder" },
  { label: "CXO", zh: "首席高管", value: "CXO" },
  { label: "Partner", zh: "合伙人", value: "Partner" },
  { label: "VP", zh: "副总裁", value: "VP" },
  { label: "Head", zh: "负责人", value: "Head" },
  { label: "Director", zh: "总监", value: "Director" },
  { label: "Manager", zh: "经理", value: "Manager" },
  { label: "Senior", zh: "资深人员", value: "Senior" },
  { label: "Entry", zh: "初级人员", value: "Entry" },
  { label: "Intern", zh: "实习生", value: "Intern" },
];

export const jobFunctions: FinderOption[] = [
  { label: "Accounting", zh: "会计", value: "Accounting" },
  { label: "Administrative", zh: "行政", value: "Administrative" },
  { label: "Arts and Design", zh: "艺术与设计", value: "Arts and Design" },
  { label: "Business Development", zh: "商务拓展", value: "Business Development" },
  {
    label: "Community and Social Services",
    zh: "社区与社会服务",
    value: "Community and Social Services",
  },
  { label: "Consulting", zh: "咨询", value: "Consulting" },
  {
    label: "Customer Success and Support",
    zh: "客户成功与支持",
    value: "Customer Success and Support",
  },
  { label: "Education", zh: "教育", value: "Education" },
  { label: "Engineering", zh: "工程技术", value: "Engineering" },
  { label: "Entrepreneurship", zh: "创业", value: "Entrepreneurship" },
  { label: "Finance", zh: "财务", value: "Finance" },
  { label: "Healthcare Services", zh: "医疗服务", value: "Healthcare Services" },
  { label: "Human Resources", zh: "人力资源", value: "Human Resources" },
  { label: "Information Technology", zh: "信息技术", value: "Information Technology" },
  { label: "Legal", zh: "法务", value: "Legal" },
  { label: "Marketing", zh: "市场营销", value: "Marketing" },
  { label: "Media and Communication", zh: "媒体与传播", value: "Media and Communication" },
  {
    label: "Military and Protective Services",
    zh: "军事与安保服务",
    value: "Military and Protective Services",
  },
  { label: "Operations", zh: "运营", value: "Operations" },
  { label: "Product Management", zh: "产品管理", value: "Product Management" },
  {
    label: "Program and Project Management",
    zh: "项目管理",
    value: "Program and Project Management",
  },
  { label: "Purchasing", zh: "采购", value: "Purchasing" },
  { label: "Quality Assurance", zh: "质量保证", value: "Quality Assurance" },
  { label: "Real Estate", zh: "房地产", value: "Real Estate" },
  { label: "Research", zh: "研究", value: "Research" },
  { label: "Sales", zh: "销售", value: "Sales" },
];

export const experienceOptions: FinderOption[] = [
  { label: "Less than 1 year", zh: "少于 1 年", value: "0_1" },
  { label: "1 - 2 years", zh: "1 - 2 年", value: "1_2" },
  { label: "3 - 5 years", zh: "3 - 5 年", value: "3_5" },
  { label: "6 - 10 years", zh: "6 - 10 年", value: "6_10" },
  { label: "More than 10 years", zh: "10 年以上", value: "10" },
];

export const industries: FinderOption[] = [
  { label: "Accounting", zh: "会计", value: "Accounting" },
  { label: "Airlines/Aviation", zh: "航空运输与航空业", value: "Airlines/Aviation" },
  {
    label: "Alternative Dispute Resolution",
    zh: "替代性争议解决服务",
    value: "Alternative Dispute Resolution",
  },
  { label: "Alternative Medicine", zh: "替代医疗", value: "Alternative Medicine" },
  { label: "Animation", zh: "动画", value: "Animation" },
  { label: "Apparel & Fashion", zh: "服装与时尚", value: "Apparel & Fashion" },
  {
    label: "Architecture & Planning",
    zh: "建筑设计与规划",
    value: "Architecture & Planning",
  },
  { label: "Arts & Crafts", zh: "艺术与手工艺", value: "Arts & Crafts" },
  { label: "Automotive", zh: "汽车行业", value: "Automotive" },
  { label: "Aviation & Aerospace", zh: "航空航天", value: "Aviation & Aerospace" },
  { label: "Banking", zh: "银行业", value: "Banking" },
  { label: "Biotechnology", zh: "生物技术", value: "Biotechnology" },
  { label: "Broadcast Media", zh: "广播电视节目制作与发行", value: "Broadcast Media" },
  { label: "Building Materials", zh: "建筑材料", value: "Building Materials" },
  {
    label: "Business Supplies & Equipment",
    zh: "商用物资与设备",
    value: "Business Supplies & Equipment",
  },
  { label: "Capital Markets", zh: "资本市场", value: "Capital Markets" },
  { label: "Chemicals", zh: "化工", value: "Chemicals" },
  {
    label: "Civic & Social Organization",
    zh: "公民与社会组织",
    value: "Civic & Social Organization",
  },
  { label: "Civil Engineering", zh: "土木工程", value: "Civil Engineering" },
  {
    label: "Commercial Real Estate",
    zh: "商业地产",
    value: "Commercial Real Estate",
  },
  {
    label: "Computer & Network Security",
    zh: "计算机与网络安全",
    value: "Computer & Network Security",
  },
  { label: "Computer Games", zh: "电脑游戏", value: "Computer Games" },
  { label: "Computer Hardware", zh: "计算机硬件", value: "Computer Hardware" },
  { label: "Computer Networking", zh: "计算机网络", value: "Computer Networking" },
  { label: "Computer Software", zh: "计算机软件", value: "Computer Software" },
  { label: "Construction", zh: "建筑业", value: "Construction" },
  { label: "Consumer Electronics", zh: "消费电子", value: "Consumer Electronics" },
  { label: "Consumer Goods", zh: "消费品", value: "Consumer Goods" },
  { label: "Consumer Services", zh: "消费者服务", value: "Consumer Services" },
  { label: "Cosmetics", zh: "化妆品", value: "Cosmetics" },
  { label: "Dairy", zh: "乳制品", value: "Dairy" },
  { label: "Defense & Space", zh: "国防与航天", value: "Defense & Space" },
  { label: "Design", zh: "设计", value: "Design" },
  { label: "E-learning", zh: "在线教育", value: "E-learning" },
  { label: "Education Management", zh: "教育管理", value: "Education Management" },
  {
    label: "Electrical & Electronic Manufacturing",
    zh: "电气与电子制造",
    value: "Electrical & Electronic Manufacturing",
  },
  { label: "Entertainment", zh: "娱乐", value: "Entertainment" },
  {
    label: "Environmental Services",
    zh: "环境服务",
    value: "Environmental Services",
  },
  { label: "Events Services", zh: "活动策划与服务", value: "Events Services" },
  { label: "Executive Office", zh: "行政办公", value: "Executive Office" },
  { label: "Facilities Services", zh: "设施服务", value: "Facilities Services" },
  { label: "Farming", zh: "农业", value: "Farming" },
  { label: "Financial Services", zh: "金融服务", value: "Financial Services" },
  { label: "Fine Art", zh: "美术", value: "Fine Art" },
  { label: "Fishery", zh: "渔业", value: "Fishery" },
  { label: "Food & Beverages", zh: "食品饮料", value: "Food & Beverages" },
  { label: "Food Production", zh: "食品生产", value: "Food Production" },
  { label: "Fundraising", zh: "募资", value: "Fundraising" },
  { label: "Furniture", zh: "家具", value: "Furniture" },
  { label: "Gambling & Casinos", zh: "博彩与赌场", value: "Gambling & Casinos" },
  {
    label: "Glass, Ceramics & Concrete",
    zh: "玻璃、陶瓷与混凝土",
    value: "Glass, Ceramics & Concrete",
  },
  {
    label: "Government Administration",
    zh: "政府行政",
    value: "Government Administration",
  },
  { label: "Government Relations", zh: "政府关系", value: "Government Relations" },
  { label: "Graphic Design", zh: "平面设计", value: "Graphic Design" },
  {
    label: "Health, Wellness & Fitness",
    zh: "健康、养生与健身",
    value: "Health, Wellness & Fitness",
  },
  { label: "Higher Education", zh: "高等教育", value: "Higher Education" },
  { label: "Hospitality", zh: "酒店服务业", value: "Hospitality" },
  {
    label: "Hospital & Health Care",
    zh: "医院与医疗保健",
    value: "Hospital & Health Care",
  },
  { label: "Human Resources", zh: "人力资源", value: "Human Resources" },
  { label: "Import & Export", zh: "进出口贸易", value: "Import & Export" },
  {
    label: "Individual & Family Services",
    zh: "个人与家庭服务",
    value: "Individual & Family Services",
  },
  {
    label: "Industrial Automation",
    zh: "工业自动化",
    value: "Industrial Automation",
  },
  { label: "Information Services", zh: "信息服务", value: "Information Services" },
  {
    label: "Information Technology & Services",
    zh: "信息技术与服务",
    value: "Information Technology & Services",
  },
  { label: "Insurance", zh: "保险", value: "Insurance" },
  {
    label: "International Affairs",
    zh: "国际事务",
    value: "International Affairs",
  },
  {
    label: "International Trade & Development",
    zh: "国际贸易与发展",
    value: "International Trade & Development",
  },
  { label: "Internet", zh: "互联网", value: "Internet" },
  { label: "Investment Banking", zh: "投资银行", value: "Investment Banking" },
  {
    label: "Investment Management",
    zh: "投资管理",
    value: "Investment Management",
  },
  { label: "Judiciary", zh: "司法", value: "Judiciary" },
  { label: "Law Enforcement", zh: "执法", value: "Law Enforcement" },
  { label: "Law Practice", zh: "律师事务", value: "Law Practice" },
  { label: "Legal Services", zh: "法律服务", value: "Legal Services" },
  { label: "Legislative Office", zh: "立法机构", value: "Legislative Office" },
  {
    label: "Leisure, Travel & Tourism",
    zh: "休闲、旅行与旅游",
    value: "Leisure, Travel & Tourism",
  },
  { label: "Libraries", zh: "图书馆", value: "Libraries" },
  {
    label: "Logistics & Supply Chain",
    zh: "物流与供应链",
    value: "Logistics & Supply Chain",
  },
  {
    label: "Luxury Goods & Jewelry",
    zh: "奢侈品与珠宝",
    value: "Luxury Goods & Jewelry",
  },
  { label: "Machinery", zh: "机械", value: "Machinery" },
  {
    label: "Management Consulting",
    zh: "管理咨询",
    value: "Management Consulting",
  },
  { label: "Maritime", zh: "海事", value: "Maritime" },
  { label: "Market Research", zh: "市场研究", value: "Market Research" },
  {
    label: "Marketing & Advertising",
    zh: "营销与广告",
    value: "Marketing & Advertising",
  },
  {
    label: "Mechanical Or Industrial Engineering",
    zh: "机械或工业工程",
    value: "Mechanical Or Industrial Engineering",
  },
  { label: "Media Production", zh: "媒体制作", value: "Media Production" },
  { label: "Medical Device", zh: "医疗器械", value: "Medical Device" },
  { label: "Medical Practice", zh: "医疗诊所", value: "Medical Practice" },
  { label: "Mental Health Care", zh: "心理健康护理", value: "Mental Health Care" },
  { label: "Military", zh: "军事", value: "Military" },
  { label: "Mining & Metals", zh: "采矿与金属", value: "Mining & Metals" },
  {
    label: "Motion Pictures & Film",
    zh: "电影",
    value: "Motion Pictures & Film",
  },
  {
    label: "Museums & Institutions",
    zh: "博物馆与机构",
    value: "Museums & Institutions",
  },
  { label: "Music", zh: "音乐", value: "Music" },
  { label: "Nanotechnology", zh: "纳米技术", value: "Nanotechnology" },
  { label: "Newspapers", zh: "报业", value: "Newspapers" },
  {
    label: "Non-profit Organization Management",
    zh: "非营利组织管理",
    value: "Non-profit Organization Management",
  },
  { label: "Oil & Energy", zh: "石油与能源", value: "Oil & Energy" },
  { label: "Online Media", zh: "网络媒体", value: "Online Media" },
  {
    label: "Outsourcing/Offshoring",
    zh: "外包 / 离岸服务",
    value: "Outsourcing/Offshoring",
  },
  {
    label: "Package/Freight Delivery",
    zh: "包裹 / 货运递送",
    value: "Package/Freight Delivery",
  },
  {
    label: "Packaging & Containers",
    zh: "包装与容器",
    value: "Packaging & Containers",
  },
  {
    label: "Paper & Forest Products",
    zh: "纸业与林产品",
    value: "Paper & Forest Products",
  },
  { label: "Performing Arts", zh: "表演艺术", value: "Performing Arts" },
  { label: "Pharmaceuticals", zh: "制药", value: "Pharmaceuticals" },
  { label: "Philanthropy", zh: "慈善", value: "Philanthropy" },
  { label: "Photography", zh: "摄影", value: "Photography" },
  { label: "Plastics", zh: "塑料", value: "Plastics" },
  {
    label: "Political Organization",
    zh: "政治组织",
    value: "Political Organization",
  },
  {
    label: "Primary/Secondary Education",
    zh: "中小学教育",
    value: "Primary/Secondary Education",
  },
  { label: "Printing", zh: "印刷", value: "Printing" },
  {
    label: "Professional Training & Coaching",
    zh: "职业培训与辅导",
    value: "Professional Training & Coaching",
  },
  { label: "Program Development", zh: "项目开发", value: "Program Development" },
  { label: "Public Policy", zh: "公共政策", value: "Public Policy" },
  {
    label: "Public Relations & Communications",
    zh: "公共关系与传播",
    value: "Public Relations & Communications",
  },
  { label: "Public Safety", zh: "公共安全", value: "Public Safety" },
  { label: "Publishing", zh: "出版", value: "Publishing" },
  { label: "Railroad Manufacture", zh: "铁路制造", value: "Railroad Manufacture" },
  { label: "Ranching", zh: "畜牧业", value: "Ranching" },
  { label: "Real Estate", zh: "房地产", value: "Real Estate" },
  {
    label: "Recreational Facilities & Services",
    zh: "娱乐设施与服务",
    value: "Recreational Facilities & Services",
  },
  {
    label: "Religious Institutions",
    zh: "宗教机构",
    value: "Religious Institutions",
  },
  {
    label: "Renewables & Environment",
    zh: "可再生能源与环境",
    value: "Renewables & Environment",
  },
  { label: "Research", zh: "研究", value: "Research" },
  { label: "Restaurants", zh: "餐饮", value: "Restaurants" },
  { label: "Retail", zh: "零售", value: "Retail" },
  { label: "Shipbuilding", zh: "造船", value: "Shipbuilding" },
  { label: "Semiconductors", zh: "半导体", value: "Semiconductors" },
  {
    label: "Security & Investigations",
    zh: "安保与调查",
    value: "Security & Investigations",
  },
  { label: "Sporting Goods", zh: "体育用品", value: "Sporting Goods" },
  { label: "Sports", zh: "体育", value: "Sports" },
  {
    label: "Staffing & Recruiting",
    zh: "人才与招聘",
    value: "Staffing & Recruiting",
  },
  { label: "Supermarkets", zh: "超市", value: "Supermarkets" },
  { label: "Telecommunications", zh: "电信", value: "Telecommunications" },
  { label: "Textiles", zh: "纺织", value: "Textiles" },
  { label: "Think Tanks", zh: "智库", value: "Think Tanks" },
  { label: "Tobacco", zh: "烟草", value: "Tobacco" },
  {
    label: "Translation & Localization",
    zh: "翻译与本地化",
    value: "Translation & Localization",
  },
  {
    label: "Transportation/Trucking/Railroad",
    zh: "运输 / 货运 / 铁路",
    value: "Transportation/Trucking/Railroad",
  },
  { label: "Utilities", zh: "公用事业", value: "Utilities" },
  {
    label: "Venture Capital & Private Equity",
    zh: "风险投资与私募股权",
    value: "Venture Capital & Private Equity",
  },
  { label: "Veterinary", zh: "兽医", value: "Veterinary" },
  { label: "Warehousing", zh: "仓储", value: "Warehousing" },
  { label: "Wholesale", zh: "批发", value: "Wholesale" },
  { label: "Wine & Spirits", zh: "葡萄酒与烈酒", value: "Wine & Spirits" },
  { label: "Wireless", zh: "无线通信", value: "Wireless" },
  { label: "Writing & Editing", zh: "写作与编辑", value: "Writing & Editing" },
];

export const companySizes: FinderOption[] = [
  { label: "1-10", value: "1_10" },
  { label: "11-50", value: "11_50" },
  { label: "51-200", value: "51_200" },
  { label: "201-500", value: "201_500" },
  { label: "501-1000", value: "501_1000" },
  { label: "1001-5000", value: "1001_5000" },
  { label: "5001-10000", value: "5001-10000" },
  { label: "10001+", value: "10001" },
];

export const revenueOptions: FinderOption<number>[] = [
  { label: "$1M", value: 1000000 },
  { label: "$5M", value: 5000000 },
  { label: "$10M", value: 10000000 },
  { label: "$50M", value: 50000000 },
  { label: "$100M", value: 100000000 },
  { label: "$250M", value: 250000000 },
  { label: "$500M", value: 500000000 },
  { label: "$1B", value: 1000000000 },
]
export const tracks = {
  FinderFilterSearchBtnClick: "FinderFilterSearchBtnClick", // Finder-点击查询按钮
  FinderFilterClearAllClick: "FinderFilterClearAllClick", // Finder-点击清除所有筛选
  FinderNoResultShowInstalled: "FinderNoResultShowInstalled", // Finder-未查到结果-缺省页展示(已装插件)
  FinderNoResultShowUninstalled: "FinderNoResultShowUninstalled", // Finder-未查到结果-缺省页展示(未装插件)
  FinderInstallExtBtnClick: "FinderInstallExtBtnClick", // Finder-未查到结果-缺省页点击安装插件
  FinderSelectAllCheckboxClick: "FinderSelectAllCheckboxClick", // Finder-结果页-点击全选复选框
  FinderSaveToContactsClick: "FinderSaveToContactsClick", // Finder-结果页-点击保存到联系人列表
  FinderViewContactsBtnClick: "FinderViewContactsBtnClick", // Finder-结果页-保存成功弹窗点击查看按钮前往Contacts列表
  FinderRevealEmailClick: "FinderRevealEmailClick", // Finder-结果页-单条解锁邮箱
  FinderRevealPhoneClick: "FinderRevealPhoneClick", // Finder-结果页-单条解锁手机号
  FinderCopyEmailClick: "FinderCopyEmailClick", // Finder-结果页-点击复制邮箱
  FinderCopyPhoneClick: "FinderCopyPhoneClick", // Finder-结果页-点击复制手机号
  FinderEmailPhoneLimitModalShow: "FinderEmailPhoneLimitModalShow", // Finder-结果页-展示积分不足弹窗
  FinderEmailPhoneLimitModalClose: "FinderEmailPhoneLimitModalClose", // Finder-结果页-关闭积分不足弹窗
  FinderEmailPhoneLimitUpgradeClick: "FinderEmailPhoneLimitUpgradeClick", // Finder-结果页-积分不足弹窗点击升级
  FinderInstallExtensionPopupShow: "FinderInstallExtensionPopupShow", // Finder-展示安装插件引导弹窗
  FinderInstallExtensionPopupClose: "FinderInstallExtensionPopupClose", // Finder-关闭安装插件引导弹窗
  FinderInstallExtensionPopupInstallClick:
    "FinderInstallExtensionPopupInstallClick", // Finder-安装插件引导弹窗-点击安装
  FinderLinkedInIconClick: "FinderLinkedInIconClick", // Finder-结果页-点击领英图标
  FinderExpShowMoreClick: "FinderExpShowMoreClick", // Finder-结果页-点击展开更多履历
  FinderExpShowLessClick: "FinderExpShowLessClick", // Finder-结果页-点击收起履历
  FinderPageNextClick: "FinderPageNextClick", // Finder-结果页-点击下一页
  FinderPagePrevClick: "FinderPagePrevClick", // Finder-结果页-点击上一页
  FinderQueryLimitBtnShow: "FinderQueryLimitBtnShow", // Finder-查询额度不足-引导升级按钮展示
  FinderSearchQuotaInsufficientUpgradeButtonShow:
    "Finder_search_quota_insufficient_upgrade_button_show", // Finder-查询额度不足-引导升级按钮展示
  FinderSearchQuotaInsufficientUpgradeButtonClick:
    "Finder_search_quota_insufficient_upgrade_button_click", // Finder-查询额度不足-引导升级按钮点击
  FinderSearchQuotaLimitTipShow:
    "Finder_search_quota_limit_tip_show", // Finder-查询额度达到上限提示
  FinderContactSalesBtnShow: "FinderContactSalesBtnShow", // Finder-查询额度不足-引导联系销售按钮展示
  FinderContactSalesBtnClick: "FinderContactSalesBtnClick", // Finder-查询额度不足-点击联系销售按钮
  FinderSalesModalOpen: "FinderSalesModalOpen", // Finder-查询额度不足-打开联系销售弹窗
  FinderSalesModalClose: "FinderSalesModalClose", // Finder-查询额度不足-关闭联系销售弹窗
  FinderSalesWhatsAppClick: "FinderSalesWhatsAppClick", // Finder-查询额度不足-联系销售弹窗-点击查看WhatsApp码
  FinderSalesWeChatClick: "FinderSalesWeChatClick", // Finder-查询额度不足-联系销售弹窗-点击查看WeChat码
  FinderSalesEmailClick: "FinderSalesEmailClick", // Finder-查询额度不足-联系销售弹窗-点击邮箱
  FinderSalesFBClick: "FinderSalesFBClick", // Finder-查询额度不足-联系销售弹窗-点击Facebook
  FinderUsageWidgetClick: "FinderUsageWidgetClick", // Finder-点击剩余额度标签
  FinderUsageUpgradeBtnClick: "FinderUsageUpgradeBtnClick", // Finder-查询额度详情浮窗-点击升级按钮
  FinderContactSalesClick: "FinderContactSalesClick", // Finder-查询额度详情浮窗-点击联系销售
} as const;
